export const mergePriceAvailabilityResponseHeadless = (
  tableParts,
  priceAndAvailabilityResponse,
  currency = '',
  isForGAEvent = false
) => {
  return tableParts.map((tablePart) => {
    const priceAvailabilityData = priceAndAvailabilityResponse?.find(
      (pnaItems) => pnaItems.partNumber === tablePart.partNumber
    );

    if (!priceAvailabilityData) {
      return tablePart;
    }

    return {
      ...tablePart,
      ...priceAvailabilityData,
      ...(priceAvailabilityData.price?.formatted
        ? priceAvailabilityData.price?.formatted
        : {}),
      coreCharges: priceAvailabilityData.price?.unformatted?.coreCharges,
      enableAddToCart: priceAvailabilityData.partLevelFlags?.isAddToCartEnabled
    };
  });
};

export const mergePriceAvailabilityResponse = (
  tableParts,
  priceAndAvailabilityResponse,
  currency = '',
  isForGAEvent = false
) => {
  return tableParts.map((tablePart) => {
    const priceAvailabilityData = priceAndAvailabilityResponse?.find(
      (pnaItems) => pnaItems.partNumber === tablePart.partNumber
    );

    if (!priceAvailabilityData) {
      return tablePart;
    }

    if (!isForGAEvent) {
      return {
        ...tablePart,
        ...priceAvailabilityData,
        ...(currency && { currency })
      };
    } else if (isForGAEvent) {
      return {
        ...tablePart,
        productPriceData: {
          ...priceAvailabilityData,
          price: {
            unitPrice: priceAvailabilityData.price?.unformatted?.unitPrice,
            discountAmount:
              priceAvailabilityData.price?.unformatted?.discountedAmount
          }
        }
      };
    }

    return tablePart;
  });
};
